export default __webpack_public_path__ + "static/media/Thumb-1.e7f9550c.png";